import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {Link} from 'react-router-dom';
import { deleteSpot } from '../store/slices/savedLocationsSlice';
import ButtonLinkLightBlue from './buttons/ButtonLinkLightBlue';
import ButtonLinkCharcoal from './buttons/ButtonLinkCharcoal';

const CurrentSpotDisplay = () => {
    const dispatch = useDispatch();
    const currentSpot = useSelector(state => state.savedLocations.currentSpot);

    if (!currentSpot) {
        return <p>Click on the map to select a surf spot and view forecast!</p>;
    }

    return (
        <div>
            <div className='flex gap-2 items-baseline justify-between mb-4'>
                <h2 className='font-semibold text-lg whitespace-nowrap'>{currentSpot.name ? currentSpot.name : 'Current Spot'}</h2>
                <p className='text-xs text-custom-light-grey whitespace-nowrap'>{Number(currentSpot.latitude).toFixed(2)}, {Number(currentSpot.longitude).toFixed(2)}</p>
            </div>
            { currentSpot.name ? (
                <>
                    <ButtonLinkLightBlue href={`/location/${currentSpot.id}/forecast`} text="Forecast" />
                    {/* <ButtonLinkLightBlue href={`/location/${currentSpot.id}/view`} text="View" />
                    <ButtonLinkLightBlue href={`/location/${currentSpot.id}/edit`} text="Edit" />
                    <button onClick={() => {
                        if(window.confirm('Are you sure you want to delete this spot?')){
                        dispatch(deleteSpot(currentSpot.id));
                        }
                    }}>Delete</button> */}
                </>
            ) : (
                <div className='flex gap-2 flex-col'>
                    <ButtonLinkCharcoal href={`/location/forecast?lat=${currentSpot.latitude}&lon=${currentSpot.longitude}`} text="Forecast" />
                    <ButtonLinkLightBlue href={`/location/save?lat=${currentSpot.latitude}&lon=${currentSpot.longitude}`} text="Save Spot" />
                </div>
            )}
        </div>
    );
};

export default CurrentSpotDisplay;
